import { getDefaultConfig, getDefaultWallets } from '@rainbow-me/rainbowkit';
import {
  trustWallet,
  okxWallet,
  bitgetWallet,
  ledgerWallet,
  binanceWallet,
  safepalWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { polygon } from 'wagmi/chains';
import { http } from 'wagmi';

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
const rpcUrl = import.meta.env.VITE_POLYGON_RPC || 'https://polygon-rpc.com';

if (!projectId) {
  console.warn(
    '[wagmi] VITE_WALLETCONNECT_PROJECT_ID is not set. WalletConnect (mobile wallets) will not work.',
  );
}

// RainbowKit ships with a few popular wallets by default (MetaMask, Coinbase,
// Rainbow, WalletConnect). We extend that list with the mobile wallets that
// have heavy usage in India / SEA — most importantly Trust Wallet — so they
// appear as first-class options in the Connect Wallet modal.
const { wallets: defaultWallets } = getDefaultWallets();

// Polygon is the ONLY chain this app declares. With no other chain in the
// list, RainbowKit/wagmi never operate on or offer Ethereum mainnet, so the
// Connect modal and network switching stay on Polygon (chain 137).
export const wagmiConfig = getDefaultConfig({
  appName: 'AltCoinsMoney',
  projectId: projectId || 'fallback',
  wallets: [
    ...defaultWallets,
    {
      groupName: 'Popular Mobile Wallets',
      wallets: [trustWallet, okxWallet, bitgetWallet, binanceWallet, safepalWallet, ledgerWallet],
    },
  ],
  chains: [polygon],
  transports: {
    [polygon.id]: http(rpcUrl),
  },
  ssr: false,
});

export const POLYGON_CHAIN_ID = polygon.id;
